/**
 * File forms.js.
 *
 *
 *
 * Contains scripts to for all any custom indvidaul scripts for the whole website
 */

(function ($) {
    $(document).ready(function () {
        var $guests = $('.event-guests').find('select').attr('id');
        var $services = $('.event-services').find('select').attr('id');
        var $allergies = $('.event-allergies').find('select').attr('id');
        var $special = $('.event-special').find('select').attr('id');
        var $venueEvent = $('.event-venue').find('select').attr('id');
        var $venueTime = $('.event-time').find('select').attr('id');

        if($guests){
            var eventGuests = new CustomSelect({
                elem: $guests
            });
        }
        if($services){
            var eventServices = new CustomSelect({
                elem: $services
            });
        }
        if($allergies){
            var eventAllergies = new CustomSelect({
                elem: $allergies
            });
        }
        if($special){
            var eventSpecial = new CustomSelect({
                elem: $special
            });
        }
        if($venueTime){
            var timeEvent = new CustomSelect({
                elem: $venueTime
            });
        }
        if($venueEvent){
            var venueEvent = new CustomSelect({
                elem: $venueEvent
            });
        }

        // slice the header to change the I to red
        var $pirata = $('.gform_heading .gform_title');
        $($pirata).each(function(){
            $(this).text().split(' ');
            var text = $(this).text().split(' ');
            var input = text[0];
            var letter = 'i';
            text[0] = input.replace(letter, '<span>'+ letter +'</span>');
            $(this).html( text.join(' ') );
        })


        // on active change the position of the label
        var iwLabel = $('.input-with-label').find('input');
        $(iwLabel).focus(function(){
            var parent = $(this).parents('li.input-with-label');
            parent.find('.gfield_description').not('.validation_message').css('transform' , 'translateY(-12.5%) scale(.60) translateX(-30%)');
            console.log(parent);
        })
        $(iwLabel).blur(function(){
            var parent = $(this).parents('li.input-with-label');
            if($(this).val()!=""){
                empty = false;
                // return false;
              }else{
                  parent.find('.gfield_description').not('.validation_message').css('transform' , 'translateY(25%) scale(1)');
              }
            console.log(parent);
        })


    });

})(jQuery);